<input
  type="file"
  class="file-input"
  [accept]="requiredFileType"
  (change)="onFileSelected($event)"
  #fileUpload
/>
<div class="file-card">
  <!-- Área clicável invisível que cobre todo o card quando há um arquivo -->
  <div *ngIf="fileName" 
       class="clickable-area"
       [matTooltip]="fileName"
       (click)="handleFileClick()">
  </div>
  
  <div class="file-info">
    <div class="file-label">{{ config.label }}:</div>
    <div *ngIf="getComment()" class="file-comment">COMENTÁRIO: <span>{{ getComment() }}</span></div>
    <div *ngIf="getDate()" class="file-date">DATA: <span>{{ getDate() | date: 'dd/MM/yyyy HH:mm' }}</span></div>
    
    <!-- Mensagem quando não tem arquivo -->
    <div *ngIf="!fileName" class="no-file-message">
      {{ messagesEnum.NO_FILE_UPLOADED_YET }}
    </div>
  </div>
  
  <div class="file-actions">
    <button 
      *ngIf="!fileName && typeCes !== typeCesEnum.SHOW"
      class="attach-btn"
      (click)="fileUpload.click()">
      <mat-icon>attach_file</mat-icon>
    </button>
    <button 
      *ngIf="fileName && typeCes !== typeCesEnum.SHOW"
      class="remove-btn"
      (click)="cancelFile()">
      X
    </button>
  </div>
</div>
